import { memo, useMemo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';
import { GAME_IMAGE_SIZES } from '../../Games/Game/Game.content';
import { GamesGridSkeletonProps } from './GamesGridSkeleton.types';
import { groupByRows } from '../GamesGrid.utils';

function GamesGridSkeleton({ itemsPerRow, imageType }: GamesGridSkeletonProps) {
  const groupedGames = useMemo(
    () =>
      groupByRows(
        Array.from({ length: itemsPerRow * 10 }, (_, index) => index),
        itemsPerRow,
      ),
    [itemsPerRow],
  );

  return (
    <Box paddingHorizontal="space-600">
      {groupedGames.map((gameIds, rowIndex) => (
        <Box
          key={rowIndex}
          flexDirection="row"
          gap="space-200"
          paddingBottom="space-200"
        >
          {gameIds.map((_, colIndex) => (
            <Skeleton
              key={`${rowIndex}-${colIndex}`}
              {...GAME_IMAGE_SIZES[imageType]}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}

export default memo(GamesGridSkeleton);
